export default {
  sections: {
    alcohol_percentage: 'Alkoholgehalt: {{value}}%',
    price_per_unit: 'Preis pro {{unit}}: {{value}}',
    gtin: 'GTIN',
    ingredients: 'Zutaten',
    allergens: 'Allergene',
    additives: 'Zusatzstoffe',
    nutrition_breakdown: {
      title: 'Nährwertangaben',
      description: '100 {{unit}} enthalten:',
      items: {
        energy: 'Energie',
        fat: 'Fett',
        saturates: 'davon gesättigte Fettsäuren',
        carbohydrates: 'Kohlenhydrate',
        sugars: 'davon Zucker',
        protein: 'Eiweiß',
        salt: 'Salz',
      },
    },
  },
  units: {
    l: 'Liter',
    kg: 'Kilo',
    default: 'Einheit',
  },
};
